import {
    Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input,
    HostListener, ViewContainerRef, ComponentFactoryResolver
} from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { delay, SharedService, FeedbackStatusEnum } from '../shared';
import {
    SharedComponent, ValueTypeEnum, QuestionTypeEnum, WidthTypeEnum,
    CannabisQuestion, CannabisSection, CannabisOption, Perscriptions, ResearchCard, CannabisOptionAnswer,
    THC_CBD_Group, CannabisAnswer, MedikamenteTable, PartnerNamesEnum, Titrationsplan, showQuestionForPartner
} from './shared';
import {
    CannabisJSON, EmptyAnswer, QuestOneOptions, QuestTwoOptions, fnQuestTwoOptions, QuestThreePositiveOptions,
    QuestThreeNegativeOptions, QuestElevenOptions, QuestTwelveOptions, QuestSeventeenOptions,
    freitext
} from './data';


import Editor from '@toast-ui/editor';
import tableMergedCell from '@toast-ui/editor-plugin-table-merged-cell/dist/toastui-editor-plugin-table-merged-cell.js';

import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateFormat, CustomAdapter, CustomDateParserFormatter } from './shared/ngb-adaptor'

import { ICDCodeFinderComponent } from './icd-code-finder';
import { QuestionsInfoComponent } from './questions-info';
import { QuestionFeedbackComponent } from './question-feedback';
import { FeedbackWebinarComponent } from './feedback-webinar';

import * as $ from 'jquery';
declare var jsPanel: any;

const copeiaEmail = "info@copeia.de";


@Component({
    selector: 'app-medizinisches-cannabisantrag',
    templateUrl: "./medizinisches-cannabisantrag.component.html",
    styleUrls: ["./medizinisches-cannabisantrag.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
    ]
})
export class MedizinischesCannabisAntragComponent implements OnInit {
    @Input() partnerName: string = "";
    partnerObj: any = null;
    partnerEmail: string = copeiaEmail;
    PartnerNamesEnum = PartnerNamesEnum;

    dateFormat: string = DateFormat;

    showLoading: boolean = false;
    inputPassword: string = "";
    showForm: boolean = false;
    loginError: boolean = false;

    printEditor: Editor;
    jsPanelPopup: any;

    textEditor: Editor;

    stepper: boolean = true;

    displayNumber: number = 0;

    isFeedbackInUrl = this.sharedService.isFeedbackInUrl();
    isAntragDoc = this.sharedService.isAntragDoc();
    isAntragPatient = this.sharedService.isAntragPatient();

    ValueTypeEnum = ValueTypeEnum;
    QuestionTypeEnum = QuestionTypeEnum;
    WidthTypeEnum = WidthTypeEnum;

    CannabisJSON: CannabisSection[] = [];
    QuestSeventeenOptions = QuestSeventeenOptions;
    THC_CBD_RecommendedTexts: any[] = [];

    DocCheckLoginType: 'login_xl' | 'login_l' | 'login_m' | 'login_s' = "login_xl";
    DocCheckLoginCode: string = "";
    DocCheckLoginLogName: string = "";
    DocCheckLoginCodePartner: string = "";
    get DocCheckLoginUrl() {
        if (this.DocCheckLoginCodePartner && this.DocCheckLoginCodePartner.length) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(`https://login.doccheck.com/code/de/${this.DocCheckLoginCodePartner}/${this.DocCheckLoginType}/`);
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(`https://login.doccheck.com/code/de/${this.DocCheckLoginCode}/${this.DocCheckLoginType}/`);
    }

    get DocCheckWidth() {
        return this.DocCheckLoginType === 'login_xl' ? 467 :
            this.DocCheckLoginType === 'login_l' ? 424 :
                this.DocCheckLoginType === 'login_m' ? 311 :
                    156;
    }

    get DocCheckHeight() {
        return this.DocCheckLoginType === 'login_xl' ? 231 :
            this.DocCheckLoginType === 'login_l' ? 215 :
                this.DocCheckLoginType === 'login_m' ? 188 :
                    203;
    }


    get isPartnerPage() {
        return this.partnerName && this.partnerName.length ? true : false;
    }

    get fullYear() {
        return new Date().getFullYear();
    }

    get minDate() {
        return { year: 1910, month: 1, day: 1 }
    }

    get maxDate() {
        return { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
    }

    get panelWidth() {
        return Math.min(1400, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(1100, window.innerHeight * 0.9);
    }

    get panelFeedbackWidth() {
        return Math.min(700, window.innerWidth * 0.9);
    }

    get panelFeedbackHeight() {
        return Math.min(281, window.innerHeight * 0.9);
    }

    get jsPanelContentHeight() {
        return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
    }

    get gridBodyHeight() {
        return this.jsPanelContentHeight - 160;
    }

    get editorBodyHeight() {
        return this.jsPanelContentHeight - 10;
    }

    get literatureSuggestedOptions(): CannabisOption[] {
        let options: CannabisOption[] = [];
        const quest1_1_2 = this.getSectionQuestion(1, 1, 2);
        const quest1_1_3 = this.getSectionQuestion(1, 1, 3);

        if (quest1_1_2.answer.selected) {
            let answers: CannabisOption[] = [];
            if (quest1_1_2.valueType === ValueTypeEnum.OPTIONS) {
                answers = quest1_1_2.answer.options;
            } else if (quest1_1_2.valueType === ValueTypeEnum.OPTION) {
                answers = [quest1_1_2.answer.option];
            }
            for (var k = 0; k < answers.length; k++) {
                let item = answers[k];
                let option = quest1_1_2.dynamicOptions.find(a => a.Label === item.Label);
                if (option) {
                    options.push(option);
                } else {
                    option = quest1_1_2.options.find(a => a.Label === item.Label);
                    if (option && option.Code && option.Code.length) {
                        options.push(option);
                    }
                }
            }
        }

        if (quest1_1_3.answer.selected) {
            let answers: CannabisOption[] = [];
            if (quest1_1_3.valueType === ValueTypeEnum.OPTIONS) {
                answers = quest1_1_3.answer.options;
            } else if (quest1_1_3.valueType === ValueTypeEnum.OPTION) {
                answers = [quest1_1_3.answer.option];
            }
            for (var k = 0; k < answers.length; k++) {
                let item = answers[k];
                let option = quest1_1_3.dynamicOptions.find(a => a.Label === item.Label);
                if (option) {
                    options.push(option);
                } else {
                    option = quest1_1_3.options.find(a => a.Label === item.Label);
                    if (option && option.Code && option.Code.length) {
                        options.push(option);
                    }
                }
            }
        }

        return options;
    }

    get secOneQuestOne(): CannabisQuestion {
        const question = this.getSectionQuestion(1, 1);
        return question;
    }

    get productOneOption(): CannabisOption {
        const quest1_2 = this.getSectionQuestion(1, 1, 2);
        return quest1_2.answer.option;
    }

    get secTwoQuestTwoOption(): CannabisOption {
        const quest = this.getSectionQuestion(2, 2);
        return quest.answer.option;
    }

    get secTwoQuestOneGroup(): THC_CBD_Group {
        const quest = this.getSectionQuestion(2, 1);
        return quest.answer.thcCbdGroup;
    }

    get partnerPagePath() {
        switch (this.partnerName) {
            case PartnerNamesEnum.FOUR_20_PHARMA:
                return "420pharma";
            default:
                return this.partnerName;
        }
    }

    get stepImagePath() {
        switch (this.partnerName) {
            case PartnerNamesEnum.FOUR_20_PHARMA:
                return "private/420pharma";
            default:
                return "medizinisches";
        }
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private sharedService: SharedService,
        private sanitizer: DomSanitizer) {
        this.getAPIConfig();
    }

    getAPIConfig() {
        this.sharedService.getAPIConfig().subscribe(
            res => {
                this.DocCheckLoginCode = res.DocCheckLoginCode;
                this.DocCheckLoginLogName = res.DocCheckLoginLogName;
            }
        );
    }

    saveDocCheckLoginLogName(name) {
        if (name && !this.isAntragPatient) {
            this.sharedService.saveDocCheckLoginLogName(name).subscribe();
        }
    }

    ngOnInit(): void {
        this.onWindowResize();
        this.getPartnerConfig();
        if (this.isAntragPatient) {
            //this.fnContinueToForm();
        } else {
            const queries = this.sharedService.getUrlVars();
            const dc = queries["dc"];
            const dc_timestamp = queries["dc_timestamp"];
            if (dc && dc_timestamp) {
                if (this.isPartnerPage) {
                    let actionType = `${this.partnerName}`;
                    let textPayload = `cannabisantrag login successfully`;
                    this.sharedService.fnLogActivity(actionType, textPayload).subscribe();
                }
                this.fnContinueToForm();
            } else {
                if (this.isPartnerPage) {
                    let actionType = `${this.partnerName}`;
                    let textPayload = `cannabisantrag loading login page`;
                    this.sharedService.fnLogActivity(actionType, textPayload).subscribe();
                }
            }
        }
    }

    getPartnerConfig() {
        this.sharedService.getPartnerConfig().subscribe(res => {
            if (res) {
                let partnerObj = res[this.partnerName];
                if (partnerObj) {
                    this.partnerObj = partnerObj;
                    this.partnerEmail = partnerObj["Email"] || copeiaEmail;
                    this.DocCheckLoginCodePartner = partnerObj["DocCheckLoginCode"] || "";
                    this.saveDocCheckLoginLogName(partnerObj["DocCheckLoginLogName"]);
                } else {
                    this.partnerObj = null;
                    this.partnerEmail = copeiaEmail;
                    this.saveDocCheckLoginLogName(this.DocCheckLoginLogName);
                }
            }
        }, err => {
            this.partnerObj = null;
            this.partnerEmail = copeiaEmail;
            this.saveDocCheckLoginLogName(this.DocCheckLoginLogName);
        })
    }

    fnValidatePassword() {
        this.showLoading = true;
        this.loginError = false;
        const hashPassword = this.sharedService.convertToHash(this.inputPassword);
        this.sharedService.getProtectedPassword().subscribe(
            res => {
                if (res.AntragPassword === hashPassword) {
                    this.fnContinueToForm();
                } else {
                    this.fnShowLoginError();
                }
            },
            err => {
                this.fnShowLoginError();
            }
        )
    }

    errorTimer: any;
    async fnShowLoginError() {
        this.showLoading = false;
        this.loginError = true;
        clearTimeout(this.errorTimer);
        this.errorTimer = setTimeout(() => {
            this.loginError = false;
        }, 5000);

    }

    fnContinueToForm() {
        this.showLoading = false;
        this.showForm = true;
        this.cd.detectChanges();

        if (this.isFeedbackInUrl) {
            this.fnShowFeebackWebinarPopup();
        } else {
            const queries = this.sharedService.getUrlVars();
            const query = queries["query"];
            if (query == "open-json-popup") {
                this.ShowFileUploadConfirmationPoup();
            }
        }
        this.CannabisJSON = this.getCannabisJSON();
        this.fnLoadQuestionOptions();
    }

    getCannabisJSON() {
        let CannibsJSON: CannabisSection[] = [];
        for (var p = 0; p < CannabisJSON.length; p++) {
            const section = CannabisJSON[p];
            let questions: CannabisQuestion[] = [];
            for (var i = 0; i < section.questions.length; i++) {
                const quest = section.questions[i];
                if (this.showQuestion(quest)) {
                    if (quest.questions) {
                        let subQuestions = [];
                        for (var j = 0; j < quest.questions.length; j++) {
                            var subQuest = quest.questions[j];
                            if (this.showSubQuestion(subQuest)) {
                                subQuestions.push(subQuest);
                            }
                        }
                        quest.questions = [...subQuestions];
                    }
                    questions.push(quest);
                }
            }
            section.questions = [...questions];
            CannibsJSON.push(section);
        }
        return CannibsJSON;
    }

    fnLoadQuestionOptions() {
        const optionOne = this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 1).answer.option;
        const optionTwo = this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 2).answer.option;
        const optionThree = this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 3).answer.option;

        const filterOptions = [];
        if (optionOne.Label) {
            filterOptions.push(optionOne.Label);
        }
        if (optionTwo.Label) {
            filterOptions.push(optionTwo.Label);
        }
        if (optionThree.Label) {
            filterOptions.push(optionThree.Label);
        }

        let secOne = this.CannabisJSON.find(a => a.sectionNumber === 1);
        if (secOne && secOne.questions.find(a => a.questionNumber === 3)) {
            this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 3).questions.find(a => a.questionNumber === 1).options = QuestThreePositiveOptions(filterOptions);
            this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 3).questions.find(a => a.questionNumber === 2).options = QuestThreeNegativeOptions(filterOptions);
        }
        let secThree = this.CannabisJSON.find(a => a.sectionNumber === 3);
        if (secThree && secThree.questions.find(a => a.questionNumber === 3)) {
            this.CannabisJSON.find(a => a.sectionNumber === 3).questions.find(a => a.questionNumber === 3).options = QuestElevenOptions(filterOptions);
        }
        if (secThree && secThree.questions.find(a => a.questionNumber === 4)) {
            this.CannabisJSON.find(a => a.sectionNumber === 3).questions.find(a => a.questionNumber === 4).options = QuestTwelveOptions(filterOptions);
        }

        let quest1_2_options: CannabisOption[] = [];
        let quest1_3_options: CannabisOption[] = [];

        const questOneOption = QuestOneOptions.find(a => a.Label === optionOne.Label);
        if (questOneOption && questOneOption.options) {
            for (var i = 0; i < questOneOption.options.length; i++) {
                const _option = questOneOption.options[i];
                quest1_2_options.push(_option)
            }

            const _questOneOption = questOneOption.options.find(a => a.Label === optionTwo.Label);
            if (_questOneOption && _questOneOption.options) {
                for (var i = 0; i < _questOneOption.options.length; i++) {
                    const _option = _questOneOption.options[i];
                    quest1_3_options.push(_option)
                }
            }
        }

        if (quest1_3_options.findIndex(a => a.Label.indexOf(freitext) > -1) === -1) {
            quest1_3_options.push({ Label: freitext })
        }
        this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 2).options = quest1_2_options;
        this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 3).options = quest1_3_options;

        let quest2Options: CannabisOption[] = fnQuestTwoOptions(filterOptions);
        let quest2_1_Options: CannabisOption[] = [];

        for (var i = 0; i < QuestTwoOptions.length; i++) {
            const otherOptions = QuestTwoOptions[i].options;
            for (var j = 0; j < otherOptions.length; j++) {
                const _option = otherOptions[j];
                const index = quest2Options.findIndex(a => a.Label === _option.Label);
                if (index === -1 && quest2_1_Options.findIndex(a => a.Label === _option.Label) === -1) {
                    quest2_1_Options.push(_option)
                }
            }
        }

        this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).options = quest2Options;
        this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).questions.find(a => a.questionNumber === 1).options = quest2_1_Options;
    }

    async ShowFileUploadConfirmationPoup() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            id: "jsPanelFixed",
            headerControls: 'none',
            headerToolbar: [
                '<h4 style="color:#fff">Confirmation</h4>'
            ],
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close" style="pointer-events: auto;">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok" style="pointer-events: auto;">Ok</button>'
            ],
            panelSize: {
                width: () => { return window.innerWidth < 400 ? (window.innerWidth * 0.8) : 400; },
                height: 200
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: '',
            dragit: {
                disable: true
            },
            resizeit: {
                disable: true
            },
            content: `
                    <div class="confirmation-text">File selector window is going to launch</div>
                `,
            callback: function (panel) {

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                component.onLoad();
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);

    }

    @HostListener('window:resize', ['$event'])
    onWindowResize(event = null) {
        if (window.innerWidth <= 767) {
            this.stepper = false;
        } else {
            this.stepper = true;
        }

        if (window.innerWidth < 320) {
            this.DocCheckLoginType = 'login_s';
        } else if (window.innerWidth < 500) {
            this.DocCheckLoginType = 'login_m';
        } else if (window.innerWidth < 600) {
            this.DocCheckLoginType = 'login_l';
        } else {
            this.DocCheckLoginType = 'login_xl';
        }
    }

    returnEvent(event) {
        switch (event.type) {
            case 'load':
                this.onLoad();
                break;
            case 'save':
                this.onSave();
                break;
            case 'print':
                this.onPrint();
                break;
            case 'email':
                this.onEmail();
                break;
            case 'document':
                this.onDocument();
                break;
            case 'stepper':
                this.stepper = event.value;
                break;
            case 'info':
                if (this.isPartnerPage) {
                    window.open(`/private/${this.partnerName}/cannabisantrag`, '_blank');
                } else {
                    window.open(`/cannabisantrag`, '_blank');
                }
                break;
            case 'reload':
                this.onReload();
                break;
        }
    }

    onToggleExpanded(section, expanded) {
        section.expanded = expanded;
    }

    showQuestion(quest: CannabisQuestion) {
        return showQuestionForPartner(quest, this.partnerName);
    }
    showSubQuestion(subQuest: CannabisQuestion) {
        return showQuestionForPartner(subQuest, this.partnerName);
    }

    getSectionQuestion(sec, ques, subQues = null) {
        const questions = this.CannabisJSON.find(a => a.sectionNumber === sec).questions;
        const question = questions.find(a => a.questionNumber === ques);
        if (subQues) {
            return question.questions.find(a => a.questionNumber === subQues);
        } else {
            return question;
        }
    }

    getQuestionNumber(section: CannabisSection, question: CannabisQuestion, pIndex: Number, index: Number) {
        this.displayNumber = this.sharedService.getQuestionNumber(section, question, pIndex, index, this.displayNumber);
        return this.displayNumber;
    }

    dateChange(quest: CannabisQuestion, subQuest?: CannabisQuestion) {
        this.inputChange(quest, subQuest);
    }

    inputChange(quest: CannabisQuestion, subQuest?: CannabisQuestion) {
        quest.answer.selected = true;
        if (subQuest) {
            subQuest.answer.selected = true;
        }
    }

    filterSelectChoose(inputValue: string, section: CannabisSection, quest: CannabisQuestion, subQuest?: CannabisQuestion) {
        if (subQuest) {
            subQuest.answer.inputValue = inputValue;
        } else {
            quest.answer.inputValue = inputValue;
        }
        this.filterSelectChange(section, quest, subQuest);
    }

    filterSelectChange(section: CannabisSection, quest: CannabisQuestion, subQuest?: CannabisQuestion) {
        quest.answer.selected = true;
        if (subQuest) {
            subQuest.answer.selected = true;
            if (section.sectionNumber === 4 && quest.questionNumber === 2) {
                const option = QuestSeventeenOptions.find(a => a.Kasse === subQuest.answer.inputValue);
                if (option) {
                    const quest4_2_2 = this.getSectionQuestion(4, 2, 2);
                    quest4_2_2.answer.selected = true;
                    quest4_2_2.answer.inputValue = option.Strasse;

                    const quest4_2_3 = this.getSectionQuestion(4, 2, 3);
                    quest4_2_3.answer.selected = true;
                    quest4_2_3.answer.inputValue = option.Ort;

                    const quest4_2_4 = this.getSectionQuestion(4, 2, 4);
                    quest4_2_4.answer.selected = true;
                    quest4_2_4.answer.inputValue = option.PLZ;

                }
            }
        }
    }

    hasFreeTextActve(quest: CannabisQuestion) {
        return quest.extraInput && (quest.answer.option.Label.indexOf(quest.extraInput) > -1 || quest.answer.options.findIndex(a => a.Label.indexOf(quest.extraInput) > -1) > -1);
    }

    hasStatiFreeTextActve(quest: CannabisQuestion) {
        return quest.freeTextInput && (quest.answer.option.Label.indexOf(quest.freeTextInput) > -1 || quest.answer.options.findIndex(a => a.Label.indexOf(quest.freeTextInput) > -1) > -1);
    }

    selectOption(section: CannabisSection, quest: CannabisQuestion, option: CannabisOption, valueType: ValueTypeEnum, subQuest?: CannabisQuestion) {
        var medikamenteQuestion = false;
        if (section.sectionNumber === 1 && quest.questionNumber === 2) {
            medikamenteQuestion = true;
        }

        quest.answer.selected = true;
        if (valueType === ValueTypeEnum.OPTION) {
            if (subQuest) {
                subQuest.answer.selected = true;
                subQuest.answer.option = {
                    Label: option.Label,
                    Code: option.Code
                };
            } else {
                quest.answer.option = {
                    Label: option.Label,
                    Code: option.Code
                };
            }
        }
        else {
            if (subQuest) {
                if ((subQuest.extraInput && option.Label.indexOf(subQuest.extraInput) > -1) || (subQuest.freeTextInput && option.Label.indexOf(subQuest.freeTextInput) > -1)) {
                    medikamenteQuestion = false;
                }
                let index = subQuest.answer.options.findIndex(a => a.Label === option.Label);
                if (index == -1) {
                    subQuest.answer.options.push(option);
                    if (medikamenteQuestion) {
                        this.addNewTableRecord(option.Label);
                    }
                } else {
                    subQuest.answer.options.splice(index, 1);
                    if (medikamenteQuestion) {
                        this.removeTableRecord(option.Label);
                    }
                }
            } else {
                if ((quest.extraInput && option.Label.indexOf(quest.extraInput) > -1) || (quest.freeTextInput && option.Label.indexOf(quest.freeTextInput) > -1)) {
                    medikamenteQuestion = false;
                }
                let index = quest.answer.options.findIndex(a => a.Label === option.Label);
                if (index == -1) {
                    quest.answer.options.push(option);
                    if (medikamenteQuestion) {
                        this.addNewTableRecord(option.Label);
                    }
                } else {
                    quest.answer.options.splice(index, 1);
                    if (medikamenteQuestion) {
                        this.removeTableRecord(option.Label);
                    }
                }
            }
        }

        if (section.sectionNumber === 1 && quest.questionNumber === 1) {
            this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 3).answer = EmptyAnswer();
            this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 3).questions.find(a => a.questionNumber === 1).answer = EmptyAnswer();
            this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 3).questions.find(a => a.questionNumber === 2).answer = EmptyAnswer();
            this.CannabisJSON.find(a => a.sectionNumber === 3).questions.find(a => a.questionNumber === 3).answer = EmptyAnswer();
            this.CannabisJSON.find(a => a.sectionNumber === 3).questions.find(a => a.questionNumber === 4).answer = EmptyAnswer();

            this.fnDisplayQuestionOneOptions(section, quest, subQuest);
        }
        this.cd.detectChanges();
    }

    showAdditionalInfoForInhaltaiveOral(section: CannabisSection, quest: CannabisQuestion) {
        if (quest.valueType === ValueTypeEnum.INHALATIV_ORAL && quest.answer?.option?.Label.indexOf('Cannabisblüten') >= 0) {
            return true;
        }
        return false;
    }

    selectOptionInhalativeOral(section: CannabisSection, quest: CannabisQuestion, option: CannabisOption) {
        quest.answer.selected = true;
        quest.answer.option = {
            Label: option.Label,
            Code: option.Code
        };
        if (!this.showAdditionalInfoForInhaltaiveOral(section, quest) && quest.questions) {
            quest.questions.forEach(a => a.answer = EmptyAnswer());
        }
    }

    onSelectListButton(section: CannabisSection, quest: CannabisQuestion, subQuest: CannabisQuestion) {
        if (subQuest.answer.selected) {
            subQuest.answer.selected = false;
            subQuest.answer.options = [];
        } else {
            subQuest.answer.selected = true;
            subQuest.answer.options = subQuest.options;
        }
    }

    selectTHCCBDGroup(section: CannabisSection, quest: CannabisQuestion, group: THC_CBD_Group) {
        quest.answer.selected = true;
        quest.answer.thcCbdGroup = group;

        const secTwoQuestTwo = this.getSectionQuestion(2, 2);
        secTwoQuestTwo.answer = EmptyAnswer();
    }

    fnDisplayQuestionOneOptions(section: CannabisSection, quest: CannabisQuestion, subQuest: CannabisQuestion) {
        if (section.sectionNumber === 1 && quest.questionNumber === 1) {
            if (subQuest.questionNumber === 1) {
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 2).answer = EmptyAnswer();
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 3).answer = EmptyAnswer();

                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).answer = EmptyAnswer();
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).questions.find(a => a.questionNumber === 1).answer = EmptyAnswer();
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).questions.find(a => a.questionNumber === 2).answer = EmptyAnswer();
            }

            if (subQuest.questionNumber === 2) {
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 1).questions.find(a => a.questionNumber === 3).answer = EmptyAnswer();

                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).answer = EmptyAnswer();
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).questions.find(a => a.questionNumber === 1).answer = EmptyAnswer();
                this.CannabisJSON.find(a => a.sectionNumber === 1).questions.find(a => a.questionNumber === 2).questions.find(a => a.questionNumber === 2).answer = EmptyAnswer();
            }

            this.fnLoadQuestionOptions();
        }
    }

    updateResearchCards(quest: CannabisQuestion, cards: ResearchCard[]) {
        quest.answer.cards = cards;
        quest.answer.selected = true;
    }

    updatePerscriptions(quest: CannabisQuestion, perscriptions: Perscriptions[]) {
        quest.answer.perscriptions = perscriptions;
        quest.answer.selected = true;
    }

    updateTitrationsplan(quest: CannabisQuestion, titrationsplan: Titrationsplan) {
        quest.answer.titrationsplan = titrationsplan;
        quest.answer.selected = true;
    }

    updateSecTwoQuestTwoOption(option: CannabisOption) {
        const quest = this.getSectionQuestion(2, 2);
        quest.answer.selected = true;
        quest.answer.option = {
            Label: option.Label,
            Code: option.Code
        };
    }



    addNewTableRecord(Name) {
        const quest = this.getSectionQuestion(1, 2);
        quest.answer.medikamenteTable.push({
            Name,
            Wirkstoffmenge: "",
            Unit: "",
            Applikation: "",
            Single: false,
            Dosierung: "",
            Morgen: "0",
            Mittag: "0",
            Abend: "0",
            Nacht: "0",
            InputValue: ""
        });
    }

    removeTableRecord(Name) {
        const quest = this.getSectionQuestion(1, 2);
        const index = quest.answer.medikamenteTable.findIndex(a => a.Name === Name);
        if (index > -1) {
            quest.answer.medikamenteTable.splice(index, 1);
        }
    }

    medikaenteTableUpdate(quest: CannabisQuestion, table: MedikamenteTable[]) {
        quest.answer.medikamenteTable = table;
    }

    fnShowQuestInfo(section: CannabisSection, quest: CannabisQuestion) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(QuestionsInfoComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.sectionNumber = section.sectionNumber;
        componentRef.instance.questionNumber = quest.questionNumber;
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Weitere Informationen zum Fragebogen',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        panel.close();
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    fnShowFeebackWebinarPopup() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(FeedbackWebinarComponent);
        const componentRef = this.vcr.createComponent(factory);
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Feedback zum Webinar',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                const QTypeEnum = componentRef.instance.QuestionTypeEnum;
                                const questions = componentRef.instance.questions;
                                const payload = [];
                                for (var i = 0; i < questions.length; i++) {
                                    const question = questions[i];
                                    if (question.Visible && question.QuestionType == QTypeEnum.ACTION) {
                                        payload.push({
                                            Status: FeedbackStatusEnum.New,
                                            Type: 'webinar-feedback',
                                            Section: question.Section,
                                            SubSection: question.SubSection,
                                            Note: question.Note
                                        })
                                        if (question.Questions) {
                                            for (var j = 0; j < question.Questions.length; j++) {
                                                const _question = question.Questions[j];
                                                if (_question.Visible && _question.QuestionType == QTypeEnum.ACTION) {
                                                    payload.push({
                                                        Status: FeedbackStatusEnum.New,
                                                        Type: 'webinar-feedback',
                                                        Section: _question.Section,
                                                        SubSection: _question.SubSection,
                                                        Note: _question.Note
                                                    })
                                                }
                                            }
                                        }
                                    }
                                }
                                component.sharedService.saveFeedbackList(payload).subscribe();
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    fnShowFeedbackPopup(section: CannabisSection, quest: CannabisQuestion) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        const questionNumber = quest.displayNumber;

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(QuestionFeedbackComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.questionNumber = questionNumber;
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelFeedbackWidth; },
                height: () => { return component.panelFeedbackHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Feedback',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                const feedback = componentRef.instance.feedback;
                                component.sharedService.saveFeedback(FeedbackStatusEnum.New, 'antrag-feedback', questionNumber, '', feedback).subscribe();
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    openICDCodePopup(section: CannabisSection, quest: CannabisQuestion, subQuest?: CannabisQuestion) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(ICDCodeFinderComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        if (subQuest) {
            componentRef.instance.dynamicOptions = [...subQuest.dynamicOptions];
            componentRef.instance.selectedOptions = subQuest.valueType === ValueTypeEnum.OPTIONS ? subQuest.answer.options : [subQuest.answer.option];
            componentRef.instance.valueType = subQuest.valueType;
        } else {
            componentRef.instance.dynamicOptions = [...quest.dynamicOptions];
            componentRef.instance.selectedOptions = quest.valueType === ValueTypeEnum.OPTIONS ? quest.answer.options : [quest.answer.option];
            componentRef.instance.valueType = quest.valueType;
        }
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'ICD 10-Code-Finder',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                if (componentRef.instance.selectedOptions.length) {
                                    const options = componentRef.instance.selectedOptions;
                                    if (subQuest) {
                                        if (subQuest.valueType === ValueTypeEnum.OPTIONS) {
                                            subQuest.answer.options = options;

                                        } else {
                                            subQuest.answer.option = options[0];
                                        }
                                        subQuest.dynamicOptions = componentRef.instance.dynamicOptions;
                                        subQuest.answer.selected = true;

                                        component.fnDisplayQuestionOneOptions(section, quest, subQuest);
                                    } else {
                                        if (quest.valueType === ValueTypeEnum.OPTIONS) {
                                            quest.answer.options = options;

                                        } else {
                                            quest.answer.option = options[0];
                                        }
                                        quest.dynamicOptions = componentRef.instance.dynamicOptions;
                                    }
                                    quest.answer.selected = true;
                                }
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    getRecommended(quest: CannabisQuestion, subQuest?: CannabisQuestion) {
        const question = this.getSectionQuestion(1, 1);
        const optionOne = question.questions.find(a => a.questionNumber === 2).answer.option;
        const optionTwo = question.questions.find(a => a.questionNumber === 3).answer.option;
        let icdCode = [];
        if (optionOne.Code) {
            icdCode.push(optionOne.Code);
        }
        if (optionTwo.Code) {
            icdCode.push(optionTwo.Code);
        }
        let searchTerm = "";
        quest.showLoading = true;
        let payload = {
            ICDCode: icdCode,
            SearchTerm: searchTerm
        }
        this.sharedService.getRecommended(payload).subscribe(
            res => {
                const recommended = res || [];
                for (var i = 0; i < recommended.length; i++) {
                    if (!recommended[i].id) {
                        recommended[i].id = `${new Date().getTime() + i}`;
                    }
                    let abstract = "";
                    if (recommended[i].summary_list.length) {
                        abstract += "<ul>";
                    }
                    for (var j = 0; j < recommended[i].summary_list.length; j++) {
                        abstract += `<li>${recommended[i].summary_list[j]}</li>`;
                    }
                    if (recommended[i].summary_list.length) {
                        abstract += "</ul>";
                    }

                    const card = {
                        id: recommended[i].id,
                        title: recommended[i].title,
                        title_de: recommended[i].title_de,
                        date: recommended[i].date,
                        url: recommended[i].url,
                        mesh_terms: recommended[i].mesh_terms,
                        abstract: abstract,
                        tags: recommended[i].tags
                    }

                    if (subQuest) {
                        const cards = subQuest.answer.cards;
                        if (cards.findIndex(a => a.url === card.url) === -1) {
                            cards.push(card);
                            subQuest.answer.cards = [...cards];
                        }
                    } else {
                        const cards = quest.answer.cards;
                        if (cards.findIndex(a => a.url === card.url) === -1) {
                            cards.push(card);
                            quest.answer.cards = [...cards];
                        }
                    }
                }

                quest.showLoading = false;
            },
            err => {
                quest.showLoading = false;
            }
        )
    }

    navigateToBlockId(sectionId, questionId, section = null) {
        if (section) {
            section.expanded = true;
            this.cd.detectChanges();
        }
        const elmId = questionId ? `section_${sectionId}_question_${questionId}` : `section_${sectionId}`;
        const elm: HTMLElement = document.getElementById(elmId) as HTMLElement;
        if (elm) {
            const formBoxes = document.getElementById("form-boxes") as HTMLElement;
            const appHeader = document.getElementsByTagName("app-header")[0] as HTMLElement;
            formBoxes.scrollTo(
                {
                    top: elm.offsetTop - appHeader.clientHeight,
                    behavior: "smooth"
                }
            )
            //elm.scrollIntoView({ behavior: "smooth" });
        }
    }

    getSectionHTML(section) {
        return `## ${section} \n\n`;
    }

    getQuestionHTML(question, no = null) {
        if (no) {
            return `#### ${no}. ${question} \n`;
        } else {
            return `#### ${question} \n`;
        }
    }

    getSubQuestionHTML(question, no = null) {
        if (no) {
            return `###### ${no}. ${question} \n`;
        } else {
            return `###### ${question} \n`;
        }
    }

    getStrongHTML(text) {
        return `**${text}** \n`;
    }

    getNormalHTML(text) {
        return `${text} \n`;
    }

    getHTMLWithDot(text) {
        if (text) {
            return `* ${text} \n`;
        } else {
            return `\n`;
        }
    }

    getHTMLWithTitle(title, text) {
        if (text) {
            return `**${title}** ${text} \n`;
        } else {
            return `**${title}** \n`;
        }
    }

    getEditorHTMLContent(number: string, LEVEL: 'FIRST' | 'SECOND', section: CannabisSection, quest: CannabisQuestion, mqNumber = 0) {
        var medikamenteQuestion = false;
        if (LEVEL === 'FIRST' && section.sectionNumber === 1 && quest.questionNumber === 2) {
            medikamenteQuestion = true;
        }

        var showLabel = true;
        if (LEVEL === 'SECOND' && section.sectionNumber === 1 && mqNumber !== 1) {
            showLabel = false;
        }

        let content = "";
        if (showLabel) {
            if (LEVEL === 'FIRST') {
                content += this.getQuestionHTML(quest.question, number);
            } else if (LEVEL === 'SECOND') {
                content += this.getSubQuestionHTML(quest.question, number);
            }
        }

        if (quest.valueType === ValueTypeEnum.CARDS) {
            for (var c = 0; c < quest.answer.cards.length; c++) {
                let card = quest.answer.cards[c];
                if (card.title) {
                    content += this.getHTMLWithTitle("Title:", card.title);
                }
                if (card.title_de) {
                    content += this.getHTMLWithTitle("Title (DE):", card.title_de);
                }
                if (card.tags) {
                    for (var t = 0; t < card.tags.length; t++) {
                        content += this.getHTMLWithTitle("Popup:", card.tags[t].popup);
                        content += this.getHTMLWithTitle("Text:", card.tags[t].text);
                    }
                }
                if (card.date) {
                    content += this.getHTMLWithTitle("Date:", card.date);
                }
                if (card.url) {
                    content += this.getHTMLWithTitle("URL:", `[${card.url}](${card.url})`);
                }
                if (card.abstract) {
                    content += this.getStrongHTML("Summary");
                    content += this.getNormalHTML(card.abstract);
                }
                content += " \n";
                content += "***";
                content += " \n";
            }
        }

        if (quest.valueType === ValueTypeEnum.PERSCRIPTIONS) {
            for (var c = 0; c < quest.answer.perscriptions.length; c++) {
                let pers = quest.answer.perscriptions[c];
                if (pers.product) {
                    content += " \n";
                    content += this.getSubQuestionHTML("Empfehlung eines Präparates und der Sorte.");
                    content += this.getHTMLWithDot(pers.product);
                }
                if (pers.dosage) {
                    content += " \n";
                    content += this.getSubQuestionHTML("In welcher Dosierung soll die Therapie erfolgen?");
                    content += this.getHTMLWithDot(pers.dosage);
                }
                //if (pers.usedFor.length) {
                //    content += this.getSubQuestionHTML("Benutzt für");
                //    for (var o = 0; o < pers.usedFor.length; o++) {
                //        let label = pers.usedFor[o].Label;
                //        if (pers.usedFor[o].Code) {
                //            label += " " + pers.usedFor[o].Code;
                //        }
                //        content += this.getHTMLWithDot(label);
                //    }
                //    if (pers.value) {
                //        content += this.getHTMLWithDot(pers.value);
                //    }
                //}
                content += " \n";
            }
        }

        if (quest.valueType === ValueTypeEnum.TITRATIONSPLAN) {
            content += " \n";
            content += this.getSubQuestionHTML("Dronabinol oder Cannabisextrakt Sorte");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.dronabinolSorte || "");
            content += " \n";
            content += this.getSubQuestionHTML("Zieltagesdosis");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.zieltagesdosis || "");
            content += " \n";
            content += this.getSubQuestionHTML("Start Tagesdosis");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.startTagesdosis || "");
            content += " \n";
            content += this.getSubQuestionHTML("Anzahl der Tage für Eintititrierung");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.anzahlDerTage || "");
            content += " \n";
            content += this.getSubQuestionHTML("morgens");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.morgens || "");
            content += " \n";
            content += this.getSubQuestionHTML("mittags");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.mittags || "");
            content += " \n";
            content += this.getSubQuestionHTML("abends");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.abends || "");
            content += " \n";
            content += this.getSubQuestionHTML("zur Nacht");
            content += this.getHTMLWithDot(quest.answer.titrationsplan?.zurNacht || "");
            content += " \n";
        }

        if (quest.valueType === ValueTypeEnum.THC_CBD_GROUP) {
            const thcCbdGroup = quest.answer.thcCbdGroup;
            content += this.getHTMLWithDot(thcCbdGroup.Title);
            //if (thcCbdGroup.THC) {
            //    content += " \n";
            //    content += this.getSubQuestionHTML("THC");
            //    const val = `${thcCbdGroup.THC.Value}${thcCbdGroup.THC.Equality || ""}`
            //    content += this.getHTMLWithDot(val);
            //}
            //if (thcCbdGroup.CBD) {
            //    content += " \n";
            //    content += this.getSubQuestionHTML("CBD");
            //    const val = `${thcCbdGroup.CBD.Value}${thcCbdGroup.CBD.Equality || ""}`
            //    content += this.getHTMLWithDot(val);
            //}
        }

        let options: CannabisOptionAnswer[] = [];
        if (quest.valueType === ValueTypeEnum.OPTION) {
            options = [quest.answer.option];
        }
        if (quest.valueType === ValueTypeEnum.OPTIONS || quest.valueType === ValueTypeEnum.LIST) {
            options = quest.answer.options;
        }
        if (quest.valueType === ValueTypeEnum.INHALATIV_ORAL) {
            options = [quest.answer.option];
        }

        if (medikamenteQuestion) {
            if (quest.answer.medikamenteTable.length) {
                content += `| Name | Wirkstoffmenge | Applikation | @cols=4:Dosierung |\n`;
                content += `| --- | --- | --- | --- | --- | --- | --- |\n`;
            }
            for (var i = 0; i < quest.answer.medikamenteTable.length; i++) {
                const record = quest.answer.medikamenteTable[i];
                if (record.Single) {
                    content += `| @rows=2:${record.Name} | ${record.Wirkstoffmenge} ${record.Unit} | ${record.Applikation} | @cols=4:${record.Dosierung} |\n`;
                } else {
                    content += `| @rows=2:${record.Name} | ${record.Wirkstoffmenge} ${record.Unit} | ${record.Applikation} | ${record.Morgen} | ${record.Mittag} | ${record.Abend} | ${record.Nacht} |\n`;
                }
                content += `| @cols=6:${record.InputValue} |\n`;
            }

            for (var o = 0; o < options.length; o++) {
                const option = options[o];
                if (quest.extraInput && option.Label.indexOf(quest.extraInput) > -1) {
                    content += this.getHTMLWithDot(quest.answer.inputValue);
                } else if (quest.freeTextInput && option.Label.indexOf(quest.freeTextInput) > -1) {
                    content += this.getHTMLWithDot(quest.answer.freeTextInputValue);
                }
            }
        }
        else {
            for (var o = 0; o < options.length; o++) {
                const option = options[o];
                if (quest.extraInput && option.Label.indexOf(quest.extraInput) > -1) {
                    content += this.getHTMLWithDot(quest.answer.inputValue);
                } else if (quest.freeTextInput && option.Label.indexOf(quest.freeTextInput) > -1) {
                    content += this.getHTMLWithDot(quest.answer.freeTextInputValue);
                } else {
                    content += this.getHTMLWithDot(this.getJoinedOptionLabel(option));
                }
            }
        }

        if (quest.valueType === ValueTypeEnum.DATE || quest.valueType === ValueTypeEnum.SELECT || quest.valueType === ValueTypeEnum.FILTER_SELECT ||
            quest.valueType === ValueTypeEnum.INPUT || quest.valueType === ValueTypeEnum.TEXTAREA) {
            content += this.getHTMLWithDot(quest.answer.inputValue);
        }

        content += " \n";
        return content;
    }

    getEditorHTML() {
        let content = `## Fragebogen zum Kostenübernahmeantrag zur Behandlungen mit Medizinalcannabis.`;
        content += " \n";
        content += "***";
        content += " \n";

        const section4 = this.CannabisJSON.find(a => a.sectionNumber === 4);
        for (var i = 0; i < section4.questions.length; i++) {
            const quest = section4.questions[i];

            //<ng-container * ngIf="!quest.displayForPartners || quest.displayForPartners.indexOf(partnerName)>-1" >
            //    <ng-container * ngIf="!quest.hideForPartners || quest.hideForPartners.indexOf(partnerName)===-1" >

            if (this.showQuestion(quest)) {
                content += this.getHTMLWithTitle(quest.question + ":", "");
                if (quest.questions) {
                    for (var j = 0; j < quest.questions.length; j++) {
                        const subQuest = quest.questions[j];
                        if (this.showSubQuestion(subQuest)) {
                            content += this.getHTMLWithTitle(subQuest.question, subQuest.answer.inputValue);
                        }
                    }
                }
                content += "***";
                content += " \n";
            }
        }
        content += " \n";

        for (var p = 0; p < this.CannabisJSON.length; p++) {
            const section = this.CannabisJSON[p];
            //content += this.getSectionHTML(section.title);
            //content += " \n";

            if (section.sectionNumber !== 4) {
                for (var i = 0; i < section.questions.length; i++) {
                    const quest = section.questions[i];
                    if (this.showQuestion(quest)) {
                        const number = this.getQuestionNumber(section, quest, p, i);
                        content += this.getEditorHTMLContent(`${number}`, 'FIRST', section, quest);

                        if (quest.valueType !== ValueTypeEnum.INHALATIV_ORAL || this.showAdditionalInfoForInhaltaiveOral(section, quest)) {
                            if (quest.questions) {
                                for (var j = 0; j < quest.questions.length; j++) {
                                    const subQuest = quest.questions[j];
                                    if (this.showSubQuestion(subQuest)) {
                                        let subNumber = "";
                                        if (subQuest.questionType === QuestionTypeEnum.NUMBER) {
                                            subNumber = `${number}.${j + 1}`;
                                        }
                                        content += this.getEditorHTMLContent(subNumber, 'SECOND', section, subQuest, quest.questionNumber);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return content;
    }

    getJoinedOptionLabel(option: CannabisOptionAnswer) {
        let label = option.Label;
        if (option.Code) {
            label += " " + option.Code;
        }
        return label;
    }

    getJoinedOptionsLabel(options: CannabisOptionAnswer[]) {
        let label = "";
        options.forEach(a => {
            label += a.Label;
            if (a.Code) {
                label += " " + a.Code;
            }
            label += ", ";
        })
        return label;
    }

    initializePrintEditor(initialValue) {
        this.printEditor = new Editor({
            el: document.querySelector('#tuiPrintEditor'),
            height: this.editorBodyHeight + "px",
            initialValue: initialValue,
            initialEditType: 'wysiwyg',
            hideModeSwitch: true,
            toolbarItems: [
                ['heading', 'bold', 'italic', 'strike'],
                ['hr', 'quote'],
                ['ul', 'ol'],
                ['link'],
                ['code', 'codeblock']
            ],
            plugins: [tableMergedCell]
        });
        this.printEditor.getHTML();
    }

    getTUIEditorHTML() {
        return $("#tuiPrintEditor .toastui-editor-ww-container .toastui-editor-contents").html();
    }

    printEditorData() {
        var html = this.getTUIEditorHTML();
        this.sharedService.printHTMLData(html);
    }

    exportHTMLToDOC() {
        var html = this.getTUIEditorHTML();
        this.sharedService.exportHTMLToDOC(html);
    }

    openEditorForPrint(html) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-primary mr-2" data-type="download">In Word-Dokument exportieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="print">Drucken</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Print',
            onwindowresize: true,
            content: `<div class="tui-editor-block"><div id="tuiPrintEditor"></div></div>`,
            onstatuschange: (panel, status) => {
                if (component.printEditor) {
                    component.printEditor.setHeight(component.editorBodyHeight + "px");
                }
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                    if (component.printEditor) {
                        component.printEditor.setHeight(component.editorBodyHeight + "px");
                    }
                }
            },
            callback: function (panel) {
                component.initializePrintEditor(html);

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "print":
                                component.printEditorData();
                                break;
                            case "download":
                                component.exportHTMLToDOC();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    onLoad() {
        $("#file-input-element").click();
    }

    handelFileInputSelect(e) {
        var files = e.target.files;
        if (files.length < 1) {
            alert('Please Select a file...');
            return;
        }
        var file = files[0];
        var reader = new FileReader();
        reader.onload = this.onJSONFileLoaded.bind(this);
        reader.readAsText(file);
    }

    onJSONFileLoaded(e) {
        var jsonObj = JSON.parse(e.target.result);
        $("#file-input-opener").val('');
        if (jsonObj.jsonType === 'encrypted') {
            if (jsonObj.secretKey) {
                this.openLoadJSONPopup(jsonObj.data);
            } else {
                this.onBeforeFetchJSON(jsonObj.data, this.sharedService.defaultSecretKey);

            }
        } else {
            this.onBeforeFetchJSON(jsonObj.data, false);
        }
    }

    openLoadJSONPopup(data) {
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(SharedComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.showLoadJSONPopup(this.partnerName);
        componentRef.instance.onSaveClick = (response) => {
            this.onBeforeFetchJSON(data, response.secretKey);
        }
    }

    onBeforeFetchJSON(data, key) {
        let jsonData = {};
        if (key) {
            jsonData = this.sharedService.decryptUsingAES256(data, key);
        } else {
            jsonData = JSON.parse(data);
        }
        this.onAfterFetchJSON(jsonData);
    }

    onAfterFetchJSON(jsonData) {
        if (jsonData) {
            const items = jsonData.item;
            for (var i = 0; i < this.CannabisJSON.length; i++) {
                const section = this.CannabisJSON[i];
                for (var j = 0; j < section.questions.length; j++) {
                    const quest = section.questions[j];
                    const item = items.find(a => a.sectionNumber === section.sectionNumber && a.questionNumber === quest.questionNumber);
                    if (item) {
                        this.CannabisJSON[i].questions[j].answer = item.answer;
                        if (item.dynamicOptions) {
                            this.CannabisJSON[i].questions[j].dynamicOptions = item.dynamicOptions;
                        }
                    }
                    if (quest.questions) {
                        for (var k = 0; k < quest.questions.length; k++) {
                            const subQuest = quest.questions[k];
                            const subItem = item.questions.find(a => a.questionNumber === subQuest.questionNumber);
                            if (subItem) {
                                this.CannabisJSON[i].questions[j].questions[k].answer = subItem.answer;
                                if (subItem.dynamicOptions) {
                                    this.CannabisJSON[i].questions[j].questions[k].dynamicOptions = subItem.dynamicOptions;
                                }
                                const answer = this.CannabisJSON[i].questions[j].questions[k].answer;
                                if (subQuest.questionType === QuestionTypeEnum.EXPAND) {
                                    if ((answer.inputValue && answer.inputValue.length) || (answer.option && answer.option.Label.length) || (answer.options && answer.options.length)) {
                                        this.CannabisJSON[i].questions[j].questions[k].expanded = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        this.cd.detectChanges();
        this.fnLoadQuestionOptions();
    }

    onSave() {
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(SharedComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.showSaveJSONPopup(this.partnerName);
        componentRef.instance.onSaveClick = (response) => {
            this.onDownload(response.fileName, response.secretType, response.secretKey);
        }
    }

    onDownload(fileName, secretType, secretKey) {
        let item = [];
        for (var i = 0; i < this.CannabisJSON.length; i++) {
            const section = this.CannabisJSON[i];
            for (var j = 0; j < section.questions.length; j++) {
                const quest = section.questions[j];
                let question = quest.question;
                let answer = quest.answer;

                let subItems = [];
                if (quest.questions) {
                    for (var k = 0; k < quest.questions.length; k++) {
                        const subQuest = quest.questions[k];
                        subItems.push({
                            questionNumber: subQuest.questionNumber,
                            question: subQuest.question,
                            dynamicOptions: subQuest.hasDynamicOptions ? subQuest.dynamicOptions : undefined,
                            answer: subQuest.answer
                        })
                    }
                }

                item.push({
                    sectionNumber: section.sectionNumber,
                    questionNumber: quest.questionNumber,
                    question: question,
                    dynamicOptions: quest.hasDynamicOptions ? quest.dynamicOptions : undefined,
                    answer: answer,
                    questions: subItems
                })
            }
        }

        var jsonObj = {
            resourceType: 'QuestionnaireResponse',
            status: 'completed',
            authored: new Date(),
            page: window.location.pathname,
            item: item
        }
        this.sharedService.downladJSON(fileName, secretType, secretKey, jsonObj);
    }

    onPrint() {
        let html = this.getEditorHTML();
        this.openEditorForPrint(html);
    }

    onDocument() {
    }

    onEmail() {

    }

    checkEmptyAnswer(answer: CannabisAnswer) {
        const emptyAnswer = EmptyAnswer();
        if (
            answer.selected != emptyAnswer.selected
            || answer.inputValue != emptyAnswer.inputValue
            || answer.freeTextInputValue != emptyAnswer.freeTextInputValue
            || answer.options.length != emptyAnswer.options.length
            || answer.cards.length != emptyAnswer.cards.length
            || answer.option.Label != emptyAnswer.option.Label
            || answer.thcCbdGroup.No != emptyAnswer.thcCbdGroup.No
            || (answer.perscriptions.length && answer.perscriptions[0].product != "" && answer.perscriptions[0].dosage != "")
        ) {
            return true;
        }
        return false;
    }

    onReload() {
        var showPopup = false;
        for (var i = 0; i < this.CannabisJSON.length; i++) {
            const section = this.CannabisJSON[i];
            for (var j = 0; j < section.questions.length; j++) {
                const quest = section.questions[j];
                showPopup = this.checkEmptyAnswer(quest.answer);
                if (showPopup) {
                    break;
                }
                if (quest.questions) {
                    for (var k = 0; k < quest.questions.length; k++) {
                        const subQuest = quest.questions[k];
                        showPopup = this.checkEmptyAnswer(subQuest.answer);
                        if (showPopup) {
                            break;
                        }
                    }
                }
            }
            if (showPopup) {
                break;
            }
        }

        if (showPopup) {
            this.fnShowReloadConfirmation();
        }
    }


    fnShowReloadConfirmation() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            id: "jsPanelFixed",
            headerControls: 'none',
            headerToolbar: [
                '<h4 style="color:#fff">Confirmation</h4>'
            ],
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close" style="pointer-events: auto;">Nein</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok" style="pointer-events: auto;">Ja</button>'
            ],
            panelSize: {
                width: () => { return window.innerWidth < 500 ? (window.innerWidth * 0.8) : 500; },
                height: 200
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: '',
            dragit: {
                disable: true
            },
            resizeit: {
                disable: true
            },
            content: `<div class="reload-confirm-text">
                        <div>Möchten Sie das Antragsformular neu starten?</div>
                        <p>Ihre bisherigen Eingaben werden überschrieben.</p>
                    </div>
                `,
            callback: function (panel) {

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                component.fnReloadForm();
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    fnReloadForm() {
        this.THC_CBD_RecommendedTexts = [];
        for (var i = 0; i < this.CannabisJSON.length; i++) {
            const section = this.CannabisJSON[i];
            for (var j = 0; j < section.questions.length; j++) {
                const quest = section.questions[j];
                this.CannabisJSON[i].questions[j].answer = EmptyAnswer();
                this.CannabisJSON[i].questions[j].dynamicOptions = [];
                this.CannabisJSON[i].questions[j].filterText = "";
                if (quest.questions) {
                    for (var k = 0; k < quest.questions.length; k++) {
                        this.CannabisJSON[i].questions[j].questions[k].answer = EmptyAnswer();
                        this.CannabisJSON[i].questions[j].questions[k].dynamicOptions = [];
                        this.CannabisJSON[i].questions[j].questions[k].filterText = "";
                    }
                }
            }
        }
        this.cd.detectChanges();
        this.fnLoadQuestionOptions();
    }
}
